import { AppConfig, AppSource, StageAppUrl, StageEnv, StageExternalUrl } from '@application/config';

export const environment: AppConfig = {
  appSource: AppSource.Ediz,
  app_id: 'livepickup',
  environment: 'stage',
  apiUrl: StageEnv,
  externalUrl: StageExternalUrl,
  version: '1.0.0',
  appUrl: StageAppUrl,
};
